import React from 'react';
import { Quote } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-white" data-id="element-134">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <Quote className="w-12 h-12 text-brand-gold mx-auto mb-6 opacity-50" data-id="element-137" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-teal mb-8 italic" data-id="element-138">
            "Sé lo que es llorar en la cocina a las dos de la mañana..."
          </h2>

          <div className="space-y-6 text-lg text-gray-700 text-left md:text-center" data-id="element-139">
            <p data-id="element-140">
              Sé lo que se siente ver a tu hijo y sentir que hay un vidrio
              invisible entre los dos. Durante años te dijeron que el autismo es
              una "condena" de conducta y que tu único camino era la
              resignación.
            </p>
            <p className="font-bold text-xl text-red-600" data-id="element-141">Te mintieron.</p>
          </div>
        </div>

        <div className="bg-brand-light rounded-2xl p-8 md:p-12 border-l-4 border-brand-teal shadow-sm" data-id="element-142">
          <h3 className="text-2xl font-serif font-bold text-brand-teal mb-4" data-id="element-143">
            La Revelación que lo Cambia Todo
          </h3>
          <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-144">
            El 80% de los niños en el espectro tienen el intestino perforado.
            Esa sangre intoxicada llega al cerebro y genera una "estática"
            permanente.
          </p>
          <p className="text-gray-700 font-medium leading-relaxed" data-id="element-145">
            El niño no se desconecta porque quiere; se desconecta porque su
            cuerpo está inflamado y saturado de metales.{' '}
            <span className="bg-brand-gold/20 px-2 py-1 rounded text-brand-dark font-bold" data-id="element-146">
              No es autismo, es intoxicación.
            </span>
          </p>
        </div>
      </div>
    </section>;
}